import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import KontaktHero from "./sections/KontaktHero";
import ContactForm from "./sections/ContactForm";
import MapaAAdresa from "./sections/MapaAAdresa";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <KontaktHero />
      <ContactForm />
      <MapaAAdresa />
      <Footer />
    </div>;
}